import thunk from "redux-thunk";
import promise from "redux-promise-middleware";
import { createBrowserHistory } from "history";
import { routerMiddleware } from "connected-react-router";
import reducers from "./rootReducer";
import { createStore as dynamicStore } from "redux-dynamic-modules";
import Auth from "src/ducks/Auth";

export const history = createBrowserHistory();

const staticModule = () => ({
  id: "static",
  reducerMap: reducers(history),
});

const configureStore = railsProps =>
  dynamicStore(
    /* initial state */
    {},

    /** enhancers **/
    [],

    /* extensions to include */
    [
      {
        middleware: [
          routerMiddleware(history),
          promise(),
          thunk,
        ],
      },
    ],

    staticModule(),
    Auth.module()
  );

export default configureStore();
